import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import _ from "lodash";
import {GeneralService} from "../../services/generalService";

@Component({
	selector: 'training-videos-component',
	templateUrl: './training-videos.component.html',
})
export class TrainingVideosComponent implements OnInit, AfterViewInit, OnDestroy {
	constructor(private sanitizer: DomSanitizer, private zone: NgZone, public gs: GeneralService) {}

	private _scrollEl: HTMLDivElement | null = null;

	@ViewChild('scrollContainer') set scrollContainer(ref: ElementRef<HTMLDivElement>) {
		if (this._scrollEl) {
			this._scrollEl.removeEventListener('scroll', this._onScroll);
		}
		this._scrollEl = ref?.nativeElement ?? null;
		if (this._scrollEl) {
			this._scrollEl.addEventListener('scroll', this._onScroll);
			setTimeout(() => this._onScroll(), 50);
		}
	}

	activeCategory = '';
	searchVideoTxt = '';
	currentVideo: any = null;
	currentVideoIframeUrl: SafeResourceUrl = null;
	videosByCategory: {category: string, videos: any[]}[] = [];
	visibleVideoCount = 0;
	showCopyLink = false;

	readonly cfStreamBase = 'https://customer-l20evnb6f5ogvb0i.cloudflarestream.com';

	videos: any[] = [
		// Onboarding & Integrations
		{id: 'f1f1fdef20aaaa2413fe82aa522c09d5', title: 'Connecting the Exchange API Integration', category: 'Onboarding & Integrations'},
		{id: 'ed704ae0a926bc5fe1ea1179ad6f5bec', title: 'Connecting the Google API Integration', category: 'Onboarding & Integrations'},
		{id: '4bf313c207f6e707bd029f7f88a71415', title: 'Connecting the PowerShell Integration', category: 'Onboarding & Integrations'},
		{id: '67d2d8fc9a91f91b8600e5d57afb8dcb', title: 'Automated Deployment of the Outbound Relay', category: 'Onboarding & Integrations'},
		{id: '0e19cf525f5e52dfc7ffd348e7c8b5c1', title: 'Automated Deployment of the Inbound Relay', category: 'Onboarding & Integrations'},
		{id: 'e6e9a6612bdc59fd124637356fa2ca5f', title: 'Verifying Your Domain in Trustifi', category: 'Onboarding & Integrations'},
		{id: '6afff543dc82bb8b0f445b161acb9b6b', title: 'Customizing Your Look and Feel', category: 'Onboarding & Integrations'},
		{id: '6e550afee597e843ab0b4bd5de5e2d53', title: 'Office 365 Full Inbound Deployment Walkthrough', category: 'Onboarding & Integrations'},
		{id: '77a225f1151997f5a644cc4cefd0f73f', title: 'Office 365 Full Outbound Deployment Walkthrough', category: 'Onboarding & Integrations'},

		// Inbound Shield - Quarantine Management
		{id: '5ff0e93a2cd9519070099ae27ded0b6e', title: 'Release Quarantined Emails from the Trustifi portal', category: 'Inbound Shield'},
		{id: '191134170ade6ea0ff896e77f241293e', title: 'Recipient Control over Quarantined emails', category: 'Inbound Shield'},
		{id: '4fba9761b80deb515a7e0faf186b4437', title: 'Scheduled Quarantine Notifications', category: 'Inbound Shield'},
		{id: '117c2f93c4e3083da6ba9741b0107446', title: 'Threat Prevention Rules Configuration', category: 'Inbound Shield'},
		{id: '0dffd7dab42b5a327227df95d2030bb2', title: 'Adding an Inbound Reviewer', category: 'Inbound Shield'},
		{id: '4d4f8877226e76a9ea24e593b1bbe3f5', title: 'Adding a sender to the global allowlist', category: 'Inbound Shield'},
		{id: 'af6004109d35ce7e5e772d1f99101c87', title: 'Adding a sender to the global blocklist', category: 'Inbound Shield'},
		{id: 'eb447b01412bce09a49ba3b64d00d31a', title: 'Handling False Positive in Inbound Shield', category: 'Inbound Shield'},

		// Outbound Shield
		{id: 'd4fc75fe75ae92768fed277d8a8dda97', title: 'Sending Encrypted Emails with the Trustifi Outlook Add-in', category: 'Outbound Shield'},
		{id: '6c3d35a1680d3379630e6ff02a4d8af4', title: 'Sending Encrypted Emails with the Trustifi Gmail Add-in', category: 'Outbound Shield'},

		// MSP / Partners
		{id: 'cdaa24b3f34ba6c656667af0386ef842', title: 'MSP - Provisioning a new client plan', category: 'MSP / Partners'},
		{id: '43b2c0e384613f1740ac7fb05c00f9d4', title: 'MSP - Adding an Inbound Reviewer in a Client Tenant', category: 'MSP / Partners'},
		{id: '5e7aa165f177f4af552d3d7b4655c763', title: "MSP - Reviewing a User's Individual Allow/Block List", category: 'MSP / Partners'},
		{id: '7a48d0ed11d747b00538b48cff2071b3', title: 'MSP - Adding a Sender to the Global Allow/Block List', category: 'MSP / Partners'},
		{id: '173d307fbf37d888e92b171a5c274c1a', title: 'MSP - Release Quarantined Emails from the Trustifi portal', category: 'MSP / Partners'},
		{id: '944c633a9f0d9c5501b9e04ebf83b040', title: 'MSP - Releasing an Exchange Quarantined Email from the Trustifi Portal', category: 'MSP / Partners'},
		{id: 'fbc2a425c4e41600a2b05975001b9d1b', title: 'Copy Policy Wizard', category: 'MSP / Partners'},

		// Add-ins
		{id: 'a4f22eec75d3d7544fbcc5e20866bb71', title: 'Installing the Trustifi Add-in for Gmail', category: 'Add-ins'},
		{id: '46a3df7aba599b1c920381fb3efb8289', title: 'Installing the Trustifi Add-in for Outlook', category: 'Add-ins'},
		{id: '00d590a1e4edbe5cdfa60148e50b6af3', title: 'Inbound Scan with the Trustifi Gmail add-in', category: 'Add-ins'},
		{id: '0f7375e3bd88f6af2024d412bc249245', title: 'Inbound Scan with the Trustifi Outlook add-in', category: 'Add-ins'},
		{id: '1f72cfd6bb9f810fad637f2f85fb95b9', title: 'Outlook Add-in Deep Dive', category: 'Add-ins'},
	];

	ngOnInit() {
		this.showCopyLink = this.gs.userInfo?.email?.endsWith('@trustificorp.com');
		this.recomputeVideosByCategory();
		this.videos.forEach((videoObj) => {
			videoObj.thumbnail = this.getThumbnailUrl(videoObj);
		});
	}

	ngAfterViewInit() {}

	ngOnDestroy() {
		this._scrollEl?.removeEventListener('scroll', this._onScroll);
	}

	private _onScroll = () => {
		const container = this._scrollEl;
		if (!container || !this.videosByCategory.length) return;
		const containerRect = container.getBoundingClientRect();
		const targetY = containerRect.top + containerRect.height * 0.35;
		let best = '';
		let bestDist = Infinity;
		for (const g of this.videosByCategory) {
			const el = document.getElementById(this.sectionId(g.category));
			if (!el) continue;
			const dist = Math.abs(el.getBoundingClientRect().top - targetY);
			if (dist < bestDist) {
				bestDist = dist;
				best = g.category;
			}
		}
		if (best !== this.activeCategory) {
			this.zone.run(() => {
				this.activeCategory = best;
			});
		}
	};

	sectionId = (cat: string): string => 'toc-' + cat.replace(/[^a-z0-9]/gi, '-').toLowerCase();

	scrollToSection = (cat: string) => {
		const el = document.getElementById(this.sectionId(cat));
		if (!el || !this._scrollEl) {
			return;
		}

		const containerRect = this._scrollEl.getBoundingClientRect();
		const elRect = el.getBoundingClientRect();

		const offset = elRect.top - containerRect.top + this._scrollEl.scrollTop - 100;

		this._scrollEl.scrollTo({
			top: offset,
			behavior: 'smooth'
		});
	};

	getLabelColor = (cat: string): string => {
		const cats = this.videosByCategory.map(g => g.category);
		const activeIdx = cats.indexOf(this.activeCategory);
		const myIdx = cats.indexOf(cat);
		if (activeIdx < 0) return '#4a5568';
		const dist = Math.abs(activeIdx - myIdx);
		const factor = Math.max(0, 1 - dist * 0.88);
		// interpolate between primary blue (active) and near-black (far away)
		const primary = [77, 138, 240];
		const muted   = [33, 37, 41];
		const r = Math.round(muted[0] + (primary[0] - muted[0]) * factor);
		const g = Math.round(muted[1] + (primary[1] - muted[1]) * factor);
		const b = Math.round(muted[2] + (primary[2] - muted[2]) * factor);
		return `rgb(${r},${g},${b})`;
	};

	private recomputeVideosByCategory = () => {
		const visible = _.reject(this.videos, 'hide');
		this.visibleVideoCount = visible.length;
		const grouped = _.groupBy(visible, 'category');
		// Preserve the natural ordering of categories from the source array
		const categoryOrder = _.uniq(this.videos.map(v => v.category));
		this.videosByCategory = categoryOrder
			.filter(category => grouped[category]?.length)
			.map(category => ({category, videos: grouped[category]}));
	};

	getThumbnailUrl = (video: any): string => {
		const t = Math.floor(Math.random() * 28) + 10;
		return `${this.cfStreamBase}/${video.id}/thumbnails/thumbnail.jpg?time=${t}s&height=270`;
	};

	searchVideo = () => {
		const searchTerm = (this.searchVideoTxt || '').toLowerCase().trim();
		this.videos.forEach(v => {
			v.hide = !!searchTerm && !v.title.toLowerCase().includes(searchTerm);
		});
		this.recomputeVideosByCategory();
	};

	openVideo = (video: any) => {
		this.currentVideo = video;
		this.currentVideoIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
			`${this.cfStreamBase}/${video.id}/iframe?autoplay=true`
		);
	};

	closeVideo = () => {
		this.currentVideo = null;
		this.currentVideoIframeUrl = null;
	};

	// copy the original Cloudflare stream link to clipboard
	copyVideoLink = (video: any, event: Event) => {
		event.stopPropagation();
		const url = `${this.cfStreamBase}/${video.id}/watch`;
		navigator.clipboard.writeText(url);
		video.copied = true;
		setTimeout(() => {
			video.copied = false;
		}, 2000);
	};
}
